<template>
  <span class="sns-ico" :style="{ width: width + 'px', height: height + 'px' }">
    <component :is="snsLogo" :aria-label="snsName" />
  </span>
</template>

<script setup>
  import { computed } from 'vue'
  import IcoKakao from '@/assets/images/sns/ico_sns_kakao.svg'
  import IcoTid from '@/assets/images/sns/ico_sns_tid.svg'
  import IcoNaver from '@/assets/images/sns/ico_sns_naver.svg'
  import IcoFacebook from '@/assets/images/sns/ico_sns_facebook.svg'
  import IcoApple from '@/assets/images/sns/ico_sns_apple.svg'

  const props = defineProps({
    // snsName: 'kakao' | 'naver' | 'facebook' | 'tid' | 'apple'
    snsName: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 44,
    },
    height: {
      type: Number,
      default: 44,
    },
  })

  const snsLogo = computed(() => {
    const sns = {
      kakao: IcoKakao,
      tid: IcoTid,
      naver: IcoNaver,
      facebook: IcoFacebook,
      apple: IcoApple,
    }
    return sns[props.snsName] || null
  })
</script>

<style lang="scss" scoped>
  .sns-ico {
    display: block;
    flex: none;
  }
</style>
